// extracted by mini-css-extract-plugin
export default {"uppercase":"uppercase___AQZ7","hidden":"hidden__UR2Ni","icon":"icon__DEkta","fill":"fill__gdlmz"};